import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Bara!`}</h1>
    <br />
    <p>{`Application Security Engineer and Penetration Tester 🐱‍💻`}</p>
    <p>{`Switching back to my preferred industry: Software Development 👨‍💻`}</p>
    <br />
    <p>{`My WebApp portfolio 👇`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      